const WATERMARKID = 'WATER_MARK_ID';
/**
 * 给图片打水印
 */
export const addWaterMark = ({ url, workerName, phoneInfo, currentPosition }) => {
  return new Promise((resolve, reject) => {
    const id = WATERMARKID;

    if (document.getElementById(id) !== null) {
      document.body.removeChild(document.getElementById(id));
    }

    const img = new Image();
    img.src = url;
    img.onload = () => {
      // 图片真实高度
      const imgWidth = img.width;
      const imgHeight = img.height;

      const can = document.createElement('canvas');
      // 设置canvas画布大小
      can.width = imgWidth;
      can.height = imgHeight;

      const cans = can.getContext('2d');
      const fontBit = imgWidth / (750 / 100) / 4;
      console.log('fontBit: ', fontBit);
      cans.drawImage(img, 0, 0);
      cans.font = fontBit + 'px Vedana';
      cans.fillStyle = '#F32222';
      cans.textAlign = 'right';
      cans.textBaseline = 'Middle';
      cans.fillText(`救援师傅:${workerName}`, can.width, fontBit); // 水印在画布的位置x，y轴
      cans.fillText(phoneInfo, can.width, fontBit * 2);
      cans.fillText(currentPosition.formattedAddress, can.width, fontBit * 3);
      cans.fillText(`经度:${currentPosition.longitude} 纬度:${currentPosition.latitude}`, can.width, fontBit * 4);

      resolve(can.toDataURL('image/jpeg'));
    };
    img.onerror = reject;
  });
};

/**
 * 移除水印方法
 */
export const removeWatermark = () => {
  const id = WATERMARKID;
  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id));
  }
};
